export const DATABASE_SCHEMA_V1 = {
  profiles: 'id, createdAt',
  routineTemplates: 'id, profileId, [profileId+active], createdAt',
  routineStepTemplates:
    'id, profileId, routineTemplateId, &[routineTemplateId+order], category, active, createdAt',
  dailyRoutines: 'id, profileId, logicalDate, &[profileId+logicalDate], status, createdAt',
  dailySteps: 'id, profileId, dailyRoutineId, &[dailyRoutineId+order], status, createdAt',
  journalEntries: 'id, profileId, logicalDate, &[profileId+logicalDate+period], period, createdAt',
  workoutSessions: 'id, profileId, logicalDate, [profileId+logicalDate], status, createdAt',
  exerciseLogs: 'id, profileId, workoutSessionId, &[workoutSessionId+order], createdAt',
  philosophyEntries: 'id, category, createdAt',
  emotionalProtocolLogs: 'id, profileId, logicalDate, [profileId+logicalDate], createdAt',
  appPreferences: 'id, &profileId, updatedAt, createdAt',
  backupMetadata: 'id, profileId, status, createdAt',
} as const;

export type PersistenceTableName = keyof typeof DATABASE_SCHEMA_V1;
